import { createTypes, asyncAction } from "redux-action-types";
import cookiesUtils from "../utils/cookiesUtils";
import apiUtils from "../utils/apiUtils";
import authUtils from "../utils/authUtils";
// import logUtils from "../utils/logUtils";

export const types = createTypes("app/auth/", asyncAction("LOGIN"), "LOGOUT", "SET_KEY");

const isAuthenticating = () => {
  return {
    type: types.LOGIN_REQUEST,
    auth: {
      isAuthenticating: true,
    },
  };
};

const setError = () => {
  return {
    type: types.LOGIN_FAIL,
    auth: {
      isAuthenticated: false,
      isAuthenticating: false,
      error: "login.error",
    },
  };
};

const get = (token) => {
  return {
    type: types.LOGIN_SUCCESS,
    auth: {
      ...authUtils.getTokenData(token),
    },
  };
};

const setKey = (data) => {
  return {
    type: types.SET_KEY,
    auth: {
      key: data
    },
  };
};

const login = (request) => (dispatch) => {
  dispatch(isAuthenticating());
  apiUtils
    .login(request)
    .then((response) => {
      cookiesUtils.save("_at", response.data.access_token);
      dispatch(get(response.data.access_token));
    })
    .catch((err) => {
      // logUtils.captureException(err, "authActions");
      dispatch(setError());
    });
};

const logout = () => (dispatch) => {
  cookiesUtils.remove("_at");
  dispatch({
    type: types.LOGOUT,
  });
};

const verifyAuth = () => (dispatch) => {
  const token = cookiesUtils.load("_at");
  if (authUtils.isValidAccessToken(token)) {
    dispatch(get(token));
  } else {
    dispatch(logout());
  }
};

const loadKey = (data) => (dispatch) => {
  dispatch(setKey(data));
};

export default {
  login,
  logout,
  verifyAuth,
  loadKey
};
